import React, { Component } from 'react';
import { Heart } from 'lucide-react';
import { Product, Screen } from '../../types';
import { useApp } from '../../context/AppContext';
import { useNavigation } from '../../context/NavigationContext';
import { Rating } from './Rating';
interface ProductCardProps {
  product: Product;
  layout?: 'grid' | 'list';
}
export function ProductCard({
  product,
  layout = 'grid'
}: ProductCardProps) {
  const {
    wishlist,
    toggleWishlist
  } = useApp();
  const {
    navigate
  } = useNavigation();
  const isWishlisted = wishlist.includes(product.id);
  const handleWishlist = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleWishlist(product.id);
  };
  if (layout === 'list') {
    return <div onClick={() => navigate(Screen.PRODUCT_DETAIL, {
      productId: product.id
    })} className="flex gap-4 bg-white p-3 rounded-2xl shadow-sm border border-gray-50 active:scale-[0.98] transition-transform cursor-pointer" data-id="element-122">
        <div className="w-28 h-28 rounded-xl overflow-hidden bg-gray-100 shrink-0 relative" data-id="element-123">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center" onError={e => {
          ;
          (e.target as HTMLImageElement).src = `https://placehold.co/400x400/e5e7eb/9ca3af?text=${encodeURIComponent(product.name.slice(0, 12))}`;
        }} data-id="element-124" />
          {product.discount && <div className="absolute top-2 left-2 bg-error text-white text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-125">
              -{product.discount}%
            </div>}
        </div>
        <div className="flex-1 flex flex-col justify-between py-1" data-id="element-126">
          <div data-id="element-127">
            <div className="flex justify-between items-start gap-2" data-id="element-128">
              <h3 className="text-sm font-medium text-gray-900 line-clamp-2" data-id="element-129">
                {product.name}
              </h3>
              <button onClick={handleWishlist} className="p-1 -mr-1 shrink-0 text-gray-400 hover:text-error transition-colors" data-id="element-130">
                <Heart className={`w-5 h-5 ${isWishlisted ? 'fill-error text-error' : ''}`} data-id="element-131" />
              </button>
            </div>
            <div className="mt-1" data-id="element-132">
              <Rating value={product.rating} count={product.reviews} data-id="element-133" />
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-134">
            <span className="text-lg font-bold text-primary" data-id="element-135">
              ₦{product.price.toLocaleString()}
            </span>
            {product.originalPrice && <span className="text-xs text-gray-400 line-through" data-id="element-136">
                ₦{product.originalPrice.toLocaleString()}
              </span>}
          </div>
        </div>
      </div>;
  }
  return <div onClick={() => navigate(Screen.PRODUCT_DETAIL, {
    productId: product.id
  })} className="bg-white rounded-2xl shadow-sm border border-gray-50 overflow-hidden active:scale-[0.98] transition-transform cursor-pointer flex flex-col h-full" data-id="element-137">
      <div className="aspect-square w-full bg-gray-100 relative overflow-hidden" data-id="element-138">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center" onError={e => {
        ;
        (e.target as HTMLImageElement).src = `https://placehold.co/400x400/e5e7eb/9ca3af?text=${encodeURIComponent(product.name.slice(0, 12))}`;
      }} data-id="element-139" />
        {product.discount && <div className="absolute top-2 left-2 bg-error text-white text-[10px] font-bold px-2 py-1 rounded-md shadow-sm" data-id="element-140">
            -{product.discount}%
          </div>}
        <button onClick={handleWishlist} className="absolute top-2 right-2 p-1.5 bg-white/80 backdrop-blur-sm rounded-full text-gray-400 hover:text-error transition-colors shadow-sm" data-id="element-141">
          <Heart className={`w-4 h-4 ${isWishlisted ? 'fill-error text-error' : ''}`} data-id="element-142" />
        </button>
      </div>
      <div className="p-3 flex flex-col flex-1" data-id="element-143">
        <h3 className="text-sm font-medium text-gray-900 line-clamp-2 mb-1 flex-1" data-id="element-144">
          {product.name}
        </h3>
        <div className="mb-2" data-id="element-145">
          <Rating value={product.rating} data-id="element-146" />
        </div>
        <div className="flex items-center gap-1.5 flex-wrap" data-id="element-147">
          <span className="text-base font-bold text-primary" data-id="element-148">
            ₦{product.price.toLocaleString()}
          </span>
          {product.originalPrice && <span className="text-xs text-gray-400 line-through" data-id="element-149">
              ₦{product.originalPrice.toLocaleString()}
            </span>}
        </div>
      </div>
    </div>;
}